import * as M from '../../messages';
import * as S from './RemoveFromMyAccount.styles';
export interface RemoveFromMyAccountProps {
  onClick: () => void;
}
export const RemoveFromMyAccount = ({ onClick }: RemoveFromMyAccountProps) => {
  return (
    <S.Wrapper data-test-id='RemoveFromMyAccountWrapper' onClick={onClick}>
      {M.RemoveFromMyAccount}
    </S.Wrapper>
  );
};

RemoveFromMyAccount.displayName = 'RemoveFromMyAccount';
